/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ClientAnalyticsAiSummaryResponse } from '../model/clientAnalyticsAiSummaryResponse';
import { ClientAnalyticsExportHistoryResponse } from '../model/clientAnalyticsExportHistoryResponse';
import { ClientAnalyticsFilterOptionsResponse } from '../model/clientAnalyticsFilterOptionsResponse';
import { ClientAnalyticsFilterRequest } from '../model/clientAnalyticsFilterRequest';
import { ClientBrandTagResponse } from '../model/clientBrandTagResponse';
import { ClientReportSendHistoryResponse } from '../model/clientReportSendHistoryResponse';
import { ClientScheduledReportResponse } from '../model/clientScheduledReportResponse';
import { ClientBrandsRequest } from '../model/clientBrandsRequest';
import { ClientBrandsResponse } from '../model/clientBrandsResponse';
import { ClientClipsByAuthorAnalyticsResponse } from '../model/clientClipsByAuthorAnalyticsResponse';
import { ClientClipsByDateAnalyticsResponse } from '../model/clientClipsByDateAnalyticsResponse';
import { ClientClipsByMediumAnalyticsResponse } from '../model/clientClipsByMediumAnalyticsResponse';
import { ClientClipsByMediumTypeAnalyticsResponse } from '../model/clientClipsByMediumTypeAnalyticsResponse';
import { ClientClipsBySentimentAnalyticsResponse } from '../model/clientClipsBySentimentAnalyticsResponse';
import { ClientClipsByTagAnalyticsResponse } from '../model/clientClipsByTagAnalyticsResponse';
import { ClientCoverageAnalysisRequest } from '../model/clientCoverageAnalysisRequest';
import { ClientCoverageAnalysisResponse } from '../model/clientCoverageAnalysisResponse';
import { ClientCoverageDashboardRequest } from '../model/clientCoverageDashboardRequest';
import { ClientCoverageDashboardResponse } from '../model/clientCoverageDashboardResponse';
import { ClientMediaRequest } from '../model/clientMediaRequest';
import { ClientMediaResponse } from '../model/clientMediaResponse';
import { ClientMostCommonWordsAnalyticsResponse } from '../model/clientMostCommonWordsAnalyticsResponse';
import { ClientOverviewRequest } from '../model/clientOverviewRequest';
import { ClientOverviewResponse } from '../model/clientOverviewResponse';
import { ClientSavedAnalyticsViewResponse } from '../model/clientSavedAnalyticsViewResponse';
import { ClientSentimentRequest } from '../model/clientSentimentRequest';
import { ClientSentimentResponse } from '../model/clientSentimentResponse';
import { ClientTopicsRequest } from '../model/clientTopicsRequest';
import { ClientTopicsResponse } from '../model/clientTopicsResponse';
import { CreateSavedAnalyticsViewRequest } from '../model/createSavedAnalyticsViewRequest';
import { CreateScheduledReportRequest } from '../model/createScheduledReportRequest';
import { RenameSavedAnalyticsViewRequest } from '../model/renameSavedAnalyticsViewRequest';
import { ReportJobStatusResponse } from '../model/reportJobStatusResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ClientAnalyticsControllerService {

    protected basePath = 'https://clipping.sette-services.inellipse.com';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param startDate 
     * @param endDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getClipsByAuthorAnalytics(startDate: string, endDate: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ClientClipsByAuthorAnalyticsResponse>>;
    public getClipsByAuthorAnalytics(startDate: string, endDate: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClientClipsByAuthorAnalyticsResponse>>>;
    public getClipsByAuthorAnalytics(startDate: string, endDate: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClientClipsByAuthorAnalyticsResponse>>>;
    public getClipsByAuthorAnalytics(startDate: string, endDate: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling getClipsByAuthorAnalytics.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling getClipsByAuthorAnalytics.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClientClipsByAuthorAnalyticsResponse>>('get',`${this.basePath}/v1/client/analytics/clips-by-author`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param startDate 
     * @param endDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getClipsByDateAnalytics(startDate: string, endDate: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ClientClipsByDateAnalyticsResponse>>;
    public getClipsByDateAnalytics(startDate: string, endDate: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClientClipsByDateAnalyticsResponse>>>;
    public getClipsByDateAnalytics(startDate: string, endDate: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClientClipsByDateAnalyticsResponse>>>;
    public getClipsByDateAnalytics(startDate: string, endDate: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling getClipsByDateAnalytics.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling getClipsByDateAnalytics.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClientClipsByDateAnalyticsResponse>>('get',`${this.basePath}/v1/client/analytics/clips-by-date`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param startDate 
     * @param endDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getClipsByMediumAnalytics(startDate: string, endDate: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ClientClipsByMediumAnalyticsResponse>>;
    public getClipsByMediumAnalytics(startDate: string, endDate: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClientClipsByMediumAnalyticsResponse>>>;
    public getClipsByMediumAnalytics(startDate: string, endDate: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClientClipsByMediumAnalyticsResponse>>>;
    public getClipsByMediumAnalytics(startDate: string, endDate: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling getClipsByMediumAnalytics.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling getClipsByMediumAnalytics.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClientClipsByMediumAnalyticsResponse>>('get',`${this.basePath}/v1/client/analytics/clips-by-medium`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param startDate 
     * @param endDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getClipsByMediumTypeAnalytics(startDate: string, endDate: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ClientClipsByMediumTypeAnalyticsResponse>>;
    public getClipsByMediumTypeAnalytics(startDate: string, endDate: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClientClipsByMediumTypeAnalyticsResponse>>>;
    public getClipsByMediumTypeAnalytics(startDate: string, endDate: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClientClipsByMediumTypeAnalyticsResponse>>>;
    public getClipsByMediumTypeAnalytics(startDate: string, endDate: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling getClipsByMediumTypeAnalytics.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling getClipsByMediumTypeAnalytics.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClientClipsByMediumTypeAnalyticsResponse>>('get',`${this.basePath}/v1/client/analytics/clips-by-medium-type`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param startDate 
     * @param endDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getClipsBySentimentAnalytics(startDate: string, endDate: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ClientClipsBySentimentAnalyticsResponse>>;
    public getClipsBySentimentAnalytics(startDate: string, endDate: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClientClipsBySentimentAnalyticsResponse>>>;
    public getClipsBySentimentAnalytics(startDate: string, endDate: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClientClipsBySentimentAnalyticsResponse>>>;
    public getClipsBySentimentAnalytics(startDate: string, endDate: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling getClipsBySentimentAnalytics.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling getClipsBySentimentAnalytics.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClientClipsBySentimentAnalyticsResponse>>('get',`${this.basePath}/v1/client/analytics/clips-by-sentiment`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param startDate 
     * @param endDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getClipsByTagAnalytics(startDate: string, endDate: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ClientClipsByTagAnalyticsResponse>>;
    public getClipsByTagAnalytics(startDate: string, endDate: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClientClipsByTagAnalyticsResponse>>>;
    public getClipsByTagAnalytics(startDate: string, endDate: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClientClipsByTagAnalyticsResponse>>>;
    public getClipsByTagAnalytics(startDate: string, endDate: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling getClipsByTagAnalytics.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling getClipsByTagAnalytics.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClientClipsByTagAnalyticsResponse>>('get',`${this.basePath}/v1/client/analytics/clips-by-tag`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param startDate 
     * @param endDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMostCommonWordsAnalytics(startDate: string, endDate: string, observe?: 'body', reportProgress?: boolean): Observable<ClientMostCommonWordsAnalyticsResponse>;
    public getMostCommonWordsAnalytics(startDate: string, endDate: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientMostCommonWordsAnalyticsResponse>>;
    public getMostCommonWordsAnalytics(startDate: string, endDate: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientMostCommonWordsAnalyticsResponse>>;
    public getMostCommonWordsAnalytics(startDate: string, endDate: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling getMostCommonWordsAnalytics.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling getMostCommonWordsAnalytics.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientMostCommonWordsAnalyticsResponse>('get',`${this.basePath}/v1/client/analytics/most-common-words`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFilterOptions(observe?: 'body', reportProgress?: boolean): Observable<ClientAnalyticsFilterOptionsResponse>;
    public getFilterOptions(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientAnalyticsFilterOptionsResponse>>;
    public getFilterOptions(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientAnalyticsFilterOptionsResponse>>;
    public getFilterOptions(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientAnalyticsFilterOptionsResponse>('get',`${this.basePath}/v1/client/analytics/filter-options`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getClientBrandTags(observe?: 'body', reportProgress?: boolean): Observable<Array<ClientBrandTagResponse>>;
    public getClientBrandTags(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClientBrandTagResponse>>>;
    public getClientBrandTags(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClientBrandTagResponse>>>;
    public getClientBrandTags(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClientBrandTagResponse>>('get',`${this.basePath}/v1/client/analytics/brands`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOverviewAnalytics(body: ClientOverviewRequest, observe?: 'body', reportProgress?: boolean): Observable<ClientOverviewResponse>;
    public getOverviewAnalytics(body: ClientOverviewRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientOverviewResponse>>;
    public getOverviewAnalytics(body: ClientOverviewRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientOverviewResponse>>;
    public getOverviewAnalytics(body: ClientOverviewRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getOverviewAnalytics.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ClientOverviewResponse>('post',`${this.basePath}/v1/client/analytics/overview`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public refreshOverviewAiSummary(body: ClientOverviewRequest, observe?: 'body', reportProgress?: boolean): Observable<ClientAnalyticsAiSummaryResponse>;
    public refreshOverviewAiSummary(body: ClientOverviewRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientAnalyticsAiSummaryResponse>>;
    public refreshOverviewAiSummary(body: ClientOverviewRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientAnalyticsAiSummaryResponse>>;
    public refreshOverviewAiSummary(body: ClientOverviewRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling refreshOverviewAiSummary.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ClientAnalyticsAiSummaryResponse>('post',`${this.basePath}/v1/client/analytics/overview/ai-summary/refresh`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * AI summary polling follow-up (2026-11-01): the cheap read-only status check the frontend
     * polls every 5s while generating=true - a single opaque filtersHash (echoed back from a
     * previous getOverviewAnalytics/refreshOverviewAiSummary response), never a full
     * ClientOverviewRequest body, so this never recomputes Overview or schedules a new generation.
     *
     * @param filtersHash
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOverviewAiSummaryStatus(filtersHash: string, observe?: 'body', reportProgress?: boolean): Observable<ClientAnalyticsAiSummaryResponse>;
    public getOverviewAiSummaryStatus(filtersHash: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientAnalyticsAiSummaryResponse>>;
    public getOverviewAiSummaryStatus(filtersHash: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientAnalyticsAiSummaryResponse>>;
    public getOverviewAiSummaryStatus(filtersHash: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (filtersHash === null || filtersHash === undefined) {
            throw new Error('Required parameter filtersHash was null or undefined when calling getOverviewAiSummaryStatus.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filtersHash !== undefined && filtersHash !== null) {
            queryParameters = queryParameters.set('filtersHash', <any>filtersHash);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientAnalyticsAiSummaryResponse>('get',`${this.basePath}/v1/client/analytics/overview/ai-summary/status`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCoverageDashboardAnalytics(body: ClientCoverageDashboardRequest, observe?: 'body', reportProgress?: boolean): Observable<ClientCoverageDashboardResponse>;
    public getCoverageDashboardAnalytics(body: ClientCoverageDashboardRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientCoverageDashboardResponse>>;
    public getCoverageDashboardAnalytics(body: ClientCoverageDashboardRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientCoverageDashboardResponse>>;
    public getCoverageDashboardAnalytics(body: ClientCoverageDashboardRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getCoverageDashboardAnalytics.');
        }

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ClientCoverageDashboardResponse>('post',`${this.basePath}/v1/client/analytics/coverage-dashboard`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCoverageAnalysisAnalytics(body: ClientCoverageAnalysisRequest, observe?: 'body', reportProgress?: boolean): Observable<ClientCoverageAnalysisResponse>;
    public getCoverageAnalysisAnalytics(body: ClientCoverageAnalysisRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientCoverageAnalysisResponse>>;
    public getCoverageAnalysisAnalytics(body: ClientCoverageAnalysisRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientCoverageAnalysisResponse>>;
    public getCoverageAnalysisAnalytics(body: ClientCoverageAnalysisRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getCoverageAnalysisAnalytics.');
        }

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ClientCoverageAnalysisResponse>('post',`${this.basePath}/v1/client/analytics/coverage-analysis`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBrandsAnalytics(body: ClientBrandsRequest, observe?: 'body', reportProgress?: boolean): Observable<ClientBrandsResponse>;
    public getBrandsAnalytics(body: ClientBrandsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientBrandsResponse>>;
    public getBrandsAnalytics(body: ClientBrandsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientBrandsResponse>>;
    public getBrandsAnalytics(body: ClientBrandsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getBrandsAnalytics.');
        }

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ClientBrandsResponse>('post',`${this.basePath}/v1/client/analytics/brands`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTopicsAnalytics(body: ClientTopicsRequest, observe?: 'body', reportProgress?: boolean): Observable<ClientTopicsResponse>;
    public getTopicsAnalytics(body: ClientTopicsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientTopicsResponse>>;
    public getTopicsAnalytics(body: ClientTopicsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientTopicsResponse>>;
    public getTopicsAnalytics(body: ClientTopicsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getTopicsAnalytics.');
        }

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ClientTopicsResponse>('post',`${this.basePath}/v1/client/analytics/topics`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSentimentAnalytics(body: ClientSentimentRequest, observe?: 'body', reportProgress?: boolean): Observable<ClientSentimentResponse>;
    public getSentimentAnalytics(body: ClientSentimentRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientSentimentResponse>>;
    public getSentimentAnalytics(body: ClientSentimentRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientSentimentResponse>>;
    public getSentimentAnalytics(body: ClientSentimentRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getSentimentAnalytics.');
        }

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ClientSentimentResponse>('post',`${this.basePath}/v1/client/analytics/sentiment`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMediaAnalytics(body: ClientMediaRequest, observe?: 'body', reportProgress?: boolean): Observable<ClientMediaResponse>;
    public getMediaAnalytics(body: ClientMediaRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientMediaResponse>>;
    public getMediaAnalytics(body: ClientMediaRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientMediaResponse>>;
    public getMediaAnalytics(body: ClientMediaRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getMediaAnalytics.');
        }

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ClientMediaResponse>('post',`${this.basePath}/v1/client/analytics/media`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSavedAnalyticsViews(observe?: 'body', reportProgress?: boolean): Observable<Array<ClientSavedAnalyticsViewResponse>>;
    public getSavedAnalyticsViews(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClientSavedAnalyticsViewResponse>>>;
    public getSavedAnalyticsViews(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClientSavedAnalyticsViewResponse>>>;
    public getSavedAnalyticsViews(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClientSavedAnalyticsViewResponse>>('get',`${this.basePath}/v1/client/analytics/saved-views`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createSavedAnalyticsView(body: CreateSavedAnalyticsViewRequest, observe?: 'body', reportProgress?: boolean): Observable<ClientSavedAnalyticsViewResponse>;
    public createSavedAnalyticsView(body: CreateSavedAnalyticsViewRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientSavedAnalyticsViewResponse>>;
    public createSavedAnalyticsView(body: CreateSavedAnalyticsViewRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientSavedAnalyticsViewResponse>>;
    public createSavedAnalyticsView(body: CreateSavedAnalyticsViewRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createSavedAnalyticsView.');
        }

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ClientSavedAnalyticsViewResponse>('post',`${this.basePath}/v1/client/analytics/saved-views`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public renameSavedAnalyticsView(id: string, body: RenameSavedAnalyticsViewRequest, observe?: 'body', reportProgress?: boolean): Observable<ClientSavedAnalyticsViewResponse>;
    public renameSavedAnalyticsView(id: string, body: RenameSavedAnalyticsViewRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientSavedAnalyticsViewResponse>>;
    public renameSavedAnalyticsView(id: string, body: RenameSavedAnalyticsViewRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientSavedAnalyticsViewResponse>>;
    public renameSavedAnalyticsView(id: string, body: RenameSavedAnalyticsViewRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling renameSavedAnalyticsView.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling renameSavedAnalyticsView.');
        }

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ClientSavedAnalyticsViewResponse>('put',`${this.basePath}/v1/client/analytics/saved-views/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSavedAnalyticsView(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteSavedAnalyticsView(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteSavedAnalyticsView(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteSavedAnalyticsView(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteSavedAnalyticsView.');
        }

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/client/analytics/saved-views/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createMentionsExport(body: ClientAnalyticsFilterRequest, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public createMentionsExport(body: ClientAnalyticsFilterRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public createMentionsExport(body: ClientAnalyticsFilterRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public createMentionsExport(body: ClientAnalyticsFilterRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createMentionsExport.');
        }

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<string>>('post',`${this.basePath}/v1/client/analytics/exports`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getExportHistory(observe?: 'body', reportProgress?: boolean): Observable<Array<ClientAnalyticsExportHistoryResponse>>;
    public getExportHistory(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClientAnalyticsExportHistoryResponse>>>;
    public getExportHistory(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClientAnalyticsExportHistoryResponse>>>;
    public getExportHistory(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClientAnalyticsExportHistoryResponse>>('get',`${this.basePath}/v1/client/analytics/recent-exports`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadMentionsExport(id: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public downloadMentionsExport(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public downloadMentionsExport(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public downloadMentionsExport(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling downloadMentionsExport.');
        }

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<string>>('get',`${this.basePath}/v1/client/analytics/exports/${encodeURIComponent(String(id))}/download`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScheduledReports(observe?: 'body', reportProgress?: boolean): Observable<Array<ClientScheduledReportResponse>>;
    public getScheduledReports(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClientScheduledReportResponse>>>;
    public getScheduledReports(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClientScheduledReportResponse>>>;
    public getScheduledReports(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClientScheduledReportResponse>>('get',`${this.basePath}/v1/client/analytics/reports`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createScheduledReport(body: CreateScheduledReportRequest, observe?: 'body', reportProgress?: boolean): Observable<ClientScheduledReportResponse>;
    public createScheduledReport(body: CreateScheduledReportRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientScheduledReportResponse>>;
    public createScheduledReport(body: CreateScheduledReportRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientScheduledReportResponse>>;
    public createScheduledReport(body: CreateScheduledReportRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createScheduledReport.');
        }

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ClientScheduledReportResponse>('post',`${this.basePath}/v1/client/analytics/reports`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteScheduledReport(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteScheduledReport(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteScheduledReport(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteScheduledReport(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteScheduledReport.');
        }

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/client/analytics/reports/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendNowScheduledReport(id: string, observe?: 'body', reportProgress?: boolean): Observable<ReportJobStatusResponse>;
    public sendNowScheduledReport(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReportJobStatusResponse>>;
    public sendNowScheduledReport(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReportJobStatusResponse>>;
    public sendNowScheduledReport(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling sendNowScheduledReport.');
        }

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
        ];

        return this.httpClient.request<ReportJobStatusResponse>('post',`${this.basePath}/v1/client/analytics/reports/${encodeURIComponent(String(id))}/send-now`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public previewScheduledReport(id: string, observe?: 'body', reportProgress?: boolean): Observable<ReportJobStatusResponse>;
    public previewScheduledReport(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReportJobStatusResponse>>;
    public previewScheduledReport(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReportJobStatusResponse>>;
    public previewScheduledReport(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling previewScheduledReport.');
        }

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
        ];

        return this.httpClient.request<ReportJobStatusResponse>('post',`${this.basePath}/v1/client/analytics/reports/${encodeURIComponent(String(id))}/preview`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param jobId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportJobStatus(jobId: string, observe?: 'body', reportProgress?: boolean): Observable<ReportJobStatusResponse>;
    public getReportJobStatus(jobId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReportJobStatusResponse>>;
    public getReportJobStatus(jobId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReportJobStatusResponse>>;
    public getReportJobStatus(jobId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (jobId === null || jobId === undefined) {
            throw new Error('Required parameter jobId was null or undefined when calling getReportJobStatus.');
        }

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
        ];

        return this.httpClient.request<ReportJobStatusResponse>('get',`${this.basePath}/v1/client/analytics/reports/jobs/${encodeURIComponent(String(jobId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getReportSendHistory(observe?: 'body', reportProgress?: boolean): Observable<Array<ClientReportSendHistoryResponse>>;
    public getReportSendHistory(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClientReportSendHistoryResponse>>>;
    public getReportSendHistory(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClientReportSendHistoryResponse>>>;
    public getReportSendHistory(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClientReportSendHistoryResponse>>('get',`${this.basePath}/v1/client/analytics/reports/history`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
